import { render, staticRenderFns } from "./SAccProjectDetails.vue?vue&type=template&id=2bbfc2ac&scoped=true"
import script from "./SAccProjectDetails.vue?vue&type=script&lang=ts"
export * from "./SAccProjectDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbfc2ac",
  null
  
)

export default component.exports